import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heading } from "@/components/ui/heading";
import { Text } from "@/components/ui/text";
import Page from "../Page";

const NotFoundPage: React.FunctionComponent = () => {
  return (
    <Page className="flex flex-col items-center justify-center min-h-[calc(100vh-5rem)] text-center px-8">
      <p className="text-8xl font-thin font-display tracking-tight text-muted-foreground/40 mb-4">
        404
      </p>
      <Heading level={1} variant="lg" className="mb-2">
        Page not found
      </Heading>
      <Text variant="sm" className="text-muted-foreground mb-8 max-w-sm">
        The page you&apos;re looking for doesn&apos;t exist or may have been moved.
      </Text>
      <Button asChild>
        <Link to="/">Go home</Link>
      </Button>
    </Page>
  );
};

export default NotFoundPage;
